import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Col } from "react-bootstrap";

import { whoami, getCountryGrades, getTeachers, getSchools } from "../services/APIClient";
import { useTeacherNavigation } from "../contexts/TeacherNavigationContext";
import { TEACHER_DASHBOARD_NAVIGATION_IDS } from "../config/teacherDashboardNavigation";

import "./LeftPanel.css";

function LeftPanel({ className = "" }) {
  const { isNavigationEnabled } = useTeacherNavigation();
  const [schoolid, setSchoolid] = useState(null);
  const [teacherid, setTeacherid] = useState(null);
  const [name, setName] = useState(null);
  const [teachers, setTeachers] = useState([]);
  const [gradeLevelOptions, setGradeLevelOptions] = useState([]);
  const [teacherRoles, setTeacherRoles] = useState([]);
  // Legacy direct-report access state retained for possible restoration.
  // const [hasChatbotAccess, setHasChatbotAccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        const whoamiResponse = await whoami();
        const { schoolid, id, name, additionalRoles, countryid } =
          whoamiResponse.data.stakeholder;

        console.log(whoamiResponse);
        setSchoolid(schoolid);
        setTeacherid(id);
        setName(name);
        setTeacherRoles(additionalRoles);

        const teachersResponse = await getTeachers(schoolid);
        setTeachers(teachersResponse);

        /* Legacy direct-report tag lookup retained for possible restoration.
        const tags = await getEntityTags("teacher", id);
        const tagList = Array.isArray(tags) ? tags : tags?.data || [];
        const chatbotTag = tagList.find(
          (t) => t.tag_definition?.tag_name === "chatbot_teacher_access"
        );
        setHasChatbotAccess(chatbotTag?.tag_value === "ON");
        */
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();
  }, []);

  const handleSENCOView = () => {
    navigate("/sencoresults/detail", {
      state: {
        teachers,
        name,
        teacherid,
        schoolid,
      },
    });
  };

  const isStaging =
    window.location.href.includes("staging") ||
    window.location.href.includes("localhost") ||
    window.location.href.includes("alpaca-assessment-test");

  return (
    <Col sm={2} className={`left-panel mt-6 ${className}`.trim()}>
      <nav className="side-nav">
        <ul className="nav-list">
          <li>
            <Link to="/masterdashboard">Home</Link>
          </li>
          {isNavigationEnabled(TEACHER_DASHBOARD_NAVIGATION_IDS.ADMIN) && (
            <li>
              <Link to="/classadmindashboard">Classrooms</Link>
            </li>
          )}
          {isNavigationEnabled(TEACHER_DASHBOARD_NAVIGATION_IDS.ASSIGN_SCREENER) && (
            <li>
              <Link to="/assessmentsdashboard">Assign Screener</Link>
            </li>
          )}
          {isNavigationEnabled(TEACHER_DASHBOARD_NAVIGATION_IDS.BEFORE_SCREENING) && (
            <li>
              <Link to="/beforescreening">Before Screening</Link>
            </li>
          )}
          {isNavigationEnabled(TEACHER_DASHBOARD_NAVIGATION_IDS.STUDENT_QRS) && (
            <li>
              <Link to="/qrdashboard">Student QRs</Link>
            </li>
          )}
          {isNavigationEnabled(TEACHER_DASHBOARD_NAVIGATION_IDS.RESULTS) && (
            <li>
              {teacherRoles?.some((role) => ["SENCO", "SET", "SPECIAL EDUCATOR/SET"].includes(role.toUpperCase())) ? (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSENCOView();
                  }}
                >
                  Results
                </a>
              ) : (
                <Link to="/resultsdashboard">Results</Link>
              )}
            </li>
          )}

          {/* Legacy direct Classroom Handover navigation retained for possible restoration.
          {isNavigationEnabled(TEACHER_DASHBOARD_NAVIGATION_IDS.CLASSROOM_HANDOVER) && (
            <li><Link to="/senco/handover">Classroom Handover</Link></li>
          )} */}

          {/* {teacherRoles?.some((role) => ["SENCO", "SET"].includes(role.toUpperCase())) && (
            
          )} */}

          {isNavigationEnabled(TEACHER_DASHBOARD_NAVIGATION_IDS.REPORTING) && (
            <li className="nav-item-eoy">
              <Link to="/reporting" className="eoy-nav-link">
                Reporting
                <span className="beta-badge">BETA</span>
              </Link>
            </li>
          )}

          {isNavigationEnabled(TEACHER_DASHBOARD_NAVIGATION_IDS.ALADDIN_EXPORT) && (
            <li>
              <Link to="/aladdinexport">Aladdin Export</Link>
            </li>
          )}
          {isNavigationEnabled(TEACHER_DASHBOARD_NAVIGATION_IDS.SANDBOX) && (
            <li>
              <Link to="/sandbox">Sandbox</Link>
            </li>
          )}

          {/* EOY Report Assistant - controlled by chatbot_teacher_access tag via CSD */}
          {/* Legacy direct EOY navigation retained for possible restoration.
          {isNavigationEnabled(TEACHER_DASHBOARD_NAVIGATION_IDS.EOY_REPORT_ASSISTANT) &&
            hasChatbotAccess && (
            <li className="nav-item-eoy">
              <Link to="/eoy-report-assistant" className="eoy-nav-link">
                EOY Report Assistant
                <span className="beta-badge">BETA</span>
              </Link>
            </li>
          )} */}

          {/* SENSAI - POC, not being taken further
          {hasChatbotAccess && (
            <li className="nav-item-sensai">
              <Link to="/sensai" className="sensai-nav-link">
                SENSAI
                <span className="sensai-badge">NEW</span>
              </Link>
            </li>
          )}
          */}

          {/* AI Assistant - commented out, replaced by EOY Report Assistant
          {hasChatbotAccess && (
            <li className="nav-item-highlight">
              <Link to="/chatbot" className="chatbot-link">
                AI Assistant
                <span className="new-badge">NEW</span>
              </Link>
            </li>
          )}
          */}
        </ul>
      </nav>
    </Col>
  );
}

export default LeftPanel;
